import { render, staticRenderFns } from "./fulfillment.vue?vue&type=template&id=1f3728f9&scoped=true"
import script from "./fulfillment.vue?vue&type=script&lang=js"
export * from "./fulfillment.vue?vue&type=script&lang=js"
import style0 from "./fulfillment.vue?vue&type=style&index=0&id=1f3728f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3728f9",
  null
  
)

export default component.exports